import { Address } from 'shared/types/account';

export class StringHelpers {
  /**
   * isNumeric tests a string and returns true when it's a decimal value
   */
  static isNumeric = (val: string) => /^\d+$/.test(val);

  /**
   * capitaliseFirstLetter capitalises only the very first character of a string, leaving the
   * rest unedited
   */
  static capitaliseFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);

  static phoneDisplayFormat = (input: string): string => {
    if (!input) return '';
    const match = input?.match(/(\+?\d{1,3})?\s?(\d{3})[\s-]?(\d{3})[\s-]?(\d{4})\s?(ext\s\d+)?/);
    if (match) {
      const [, countryCode, areaCode, firstPart, secondPart, extension] = match;
      const formattedPhoneNumber = `(${areaCode}) ${firstPart}-${secondPart}`;
      if (countryCode && extension) {
        return `${formattedPhoneNumber} ext ${extension}`;
      } else if (countryCode) {
        return `+${countryCode} ${formattedPhoneNumber}`;
      } else if (extension) {
        return `${formattedPhoneNumber} ext ${extension}`;
      } else {
        return formattedPhoneNumber;
      }
    }

    return input; // Return original input if the format doesn't match
  };

  static phoneExtensionMerger = (address: Address) => {
    let phone = '';
    const addressPhone = address?.phone;
    if (address?.extension) {
      phone = address?.extension.replace(/ /g, '');
    }
    if (addressPhone !== undefined) {
      if (phone !== '') {
        phone += ` ${addressPhone.replace(/ /g, '')}`;
      } else {
        phone = `${addressPhone.replace(/ /g, '')}`;
      }
    }
    return { ...address, phone };
  };
  static checkValidCreditCard(cardNumber: string): boolean {
    const cardTypes: [string, string][] = [
      ['Visa', '^4'],
      ['MasterCard', '^(5[1-5]|2[2-7])'],
      ['American Express', '^3[47]'],
      ['Discover', '^(6011|65|64[4-9]|622)'],
      // Add more card types and their IIN/BIN ranges as needed
    ];

    for (const [cardType, pattern] of cardTypes) {
      if (new RegExp(pattern).test(cardNumber)) {
        return true;
      }
    }

    return false;
  }
}
